// import { getDutyAmount } from "../api/getEntrySummaryData";

export const calculateExciseTax = (lineItem, rateType) => {
  // rateType == 1 for percentage rate
  // rateType == 2 for specific rate
  let totalValue = 0;
  switch (rateType) {
    case 1:
      totalValue =
        lineItem.rateOfExcise *
        (parseFloat(lineItem.rateOfExcise) +
          calculateVfds(lineItem.valueForDuty) +
          parseFloat(lineItem.customsDuties) +
          parseFloat(lineItem.simaAssessment));
      break;

    case 2:
      totalValue =
        parseFloat(lineItem.rateOfExcise) * parseFloat(lineItem.quantity);
      break;

    default:
      totalValue =
        parseFloat(lineItem.rateOfExcise) * parseFloat(lineItem.quantity);
  }
  return totalValue;
};
function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }
  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  return Math.round(n) / multiplicator;
}
function truncateDecimals (num, digits) {
  var numS = num.toString(),
      decPos = numS.indexOf('.'),
      substrLength = decPos == -1 ? numS.length : 1 + decPos + digits,
      trimmedResult = numS.substr(0, substrLength),
      finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;

  return parseFloat(finalResult);
}
function calculateVfds(totalVfd) {
  let vfdTotal = totalVfd;
  if (totalVfd) {
    let indexOfDot = totalVfd.indexOf(".");
    if (indexOfDot == -1) {
      vfdTotal = roundTo(totalVfd, 2);
    }
    let totalLength = totalVfd.length;
    let decimalPlacesString = totalVfd.slice(indexOfDot + 1, totalLength);
    let decimalLength = decimalPlacesString.length;
    for (let i = decimalLength; i > 0; i--) {
      if (i > 3) {
        vfdTotal = roundTo(truncateDecimals(vfdTotal, 3), i - 1)
      } else {
        vfdTotal = roundTo(vfdTotal, 2);
      }
    }
  }
  return vfdTotal;
}
export const lineItemWiseCalculations = (obj) => {
  let qty = !obj?.quantity || obj?.quantity == "-999" ? 0 : obj?.quantity;
  let unitPrice =
    !obj?.unitPrice || obj?.unitPrice == "-999" ? 0 : obj?.unitPrice;
  let rateOfExchange =
    !obj?.rateOfExchange || obj?.rateOfExchange == "-999"
      ? 0
      : obj.rateOfExchange;
  let rateOfGst =
    !obj?.rateOfGst || obj?.rateOfGst == "-999" ? 0 : obj?.rateOfGst;

  let rateOfDuty =
    !obj?.rateOfDuty || obj?.rateOfDuty == "-999" ? 0 : obj?.rateOfDuty;

  let simaAssessment =
    !obj?.simaAssessment || obj?.simaAssessment == "-999"
      ? 0
      : Number(obj?.simaAssessment);
  let exciseTax =
    !obj?.exciseTax || obj?.exciseTax == "-999" ? 0 : Number(obj?.exciseTax);
  let currencyConversionVal = qty * unitPrice;
  if (currencyConversionVal) {
    let currencyConversionValue = Number(
      Math.round(currencyConversionVal * 100) / 100
    );
    currencyConversionVal = roundTo(currencyConversionValue, 2);
  }
  let valueForDuty = rateOfExchange
    ? currencyConversionVal * rateOfExchange
    : currencyConversionVal;
  if (valueForDuty) {
    let valueForDutie = Number(valueForDuty);
    valueForDuty = calculateVfds(`${valueForDutie}`);
  }
  function matchRegexes(str, regexes) {
    for (let i = 0; i < regexes.length; i++) {
      let regex = new RegExp(regexes[i].val);
      if (regex.test(str)) {
        return regexes[i].key;
      }
    }
    return null; // if no match is found
  }


  let regexes = [
    { key: 'dollarsPerTonne', val: '\\$\\d+\\.?\\d*\\/tonne' },
    { key: 'dollarsPerKg', val: '\\$\\d+\\.?\\d*\\/kg' },
    { key: 'centsPerTonne', val: '\\d+\\.?\\d*\\¢\\/tonne' },
    { key: 'centsPerKg', val: '\\d+\\.?\\d*\\¢\\/kg' },
    { key: 'centsPerLitre', val: '\\d+\\.?\\d*\\¢\\/litre' },
  ];

  function extractNumericValues(str) {
    let regex = /\d+\.?\d*/;
    let str1 = typeof str == "number" ?str.toString():str
    let matches = str1.match(regex);
    if (matches) {
      return matches.map((match) => parseFloat(match));
    } else {
      return [];
    }
  }
  function roundMe(value, roundTo, roundFrom) {
    return roundFrom >= roundTo ? roundMe(Math.round(value * Math.pow(10, roundFrom)) / Math.pow(10, roundFrom), roundTo, roundFrom - 1) : value;
  }

  function calculateCustomsDuties(dRate, hQty) {
    let dRateVal = extractNumericValues(dRate);
    let dRatePattern = matchRegexes(dRate,regexes);
    if (
      ['centsPerTonne', 'centsPerKg', 'centsPerLitre'].includes(dRatePattern)
    ) {
      return String(
        roundMe((parseFloat(hQty) * parseFloat(dRateVal)) / 100, 2, 4)
      );
    } else if (['dollarsPerTonne', 'dollarsPerKg'].includes(dRatePattern)) {
      return String(roundMe(parseFloat(hQty) * parseFloat(dRateVal), 2, 4));
    }
  }
  var customsDuties
  function isNumber(str) {
    return /^\d+(\.\d+)?$/.test(str);
  }
  // console.log({specialDutyRate:obj.specialDutyRate, rateOfDuty})
  if (
    (obj.specialDutyRate && obj.specialDutyRate != 0) ||
    !isNumber(rateOfDuty)
  ) {
    customsDuties = calculateCustomsDuties(
      obj.specialDutyRate && obj.specialDutyRate != 0
        ? obj.specialDutyRate
        : rateOfDuty,
      obj.hsQty == '-999' ? '0' : obj.hsQty
    );
    // console.log({customsDuties, rateOfDuty})
  } else {
    customsDuties = valueForDuty * (rateOfDuty / 100);
  } 

  if (customsDuties) {
    let customsDuty = Number(Math.round(customsDuties * 100) / 100);
    customsDuties = roundTo(customsDuty, 2);
  }
  let totalForTax =
    Number(calculateVfds(`${valueForDuty}`)) +
    Number(roundTo(customsDuties, 2)) +
    Number(roundTo(exciseTax, 2)) +
    Number(roundTo(simaAssessment, 2));
  let finalRateOfGST = rateOfGst == "5" ? rateOfGst :
                        rateOfGst == "1"  ? "5" : 0;

  let gst = totalForTax * (finalRateOfGST / 100);
  let lineItemTotal = customsDuties + simaAssessment + exciseTax + gst;

  // let calculatedValues = {
  //     "currencyConversionVal": currencyConversionVal<1 ? Math.ceil(currencyConversionVal): Math.round(currencyConversionVal),
  //     "valueForDuty":valueForDuty < 1 ? Math.ceil(valueForDuty) : Math.round(valueForDuty),
  //     "customsDuties": customsDuties <1 ? Math.ceil(customsDuties): Math.ceil(customsDuties),
  //     "totalForTax": totalForTax<1 ? Math.ceil(totalForTax): Math.round(totalForTax),
  //     "gst":  gst<1 ? Math.ceil(gst): Math.ceil(gst),
  //     "lineItemTotal":lineItemTotal
  // }

  let calculatedValues = {
    currencyConversionVal: (
      Math.round(currencyConversionVal * 100) / 100
    ).toFixed(2),
    valueForDuty: calculateVfds(`${valueForDuty}`),
    customsDuties: (Math.round(customsDuties * 100) / 100).toFixed(2),
    totalForTax: (Math.round(totalForTax * 100) / 100).toFixed(2),
    gst: roundTo(Math.round(gst * 100) / 100, 4),
    lineItemTotal: lineItemTotal,
  };
  return calculatedValues;
};

export const sumAllCustomDuties = (lineItems) => {
  let updatedTotalValue = 0;

  lineItems.forEach((lineItem) => {
    let customsDuties =
      !lineItem.customsDuties || lineItem.customsDuties == "-999"
        ? 0
        : lineItem.customsDuties;
    updatedTotalValue = updatedTotalValue + parseFloat(customsDuties);
  });
  return updatedTotalValue.toFixed(2);
};

export const sumAllSimaAssessment = (lineItems) => {
  let updatedTotalValue = 0;

  lineItems.forEach((lineItem) => {
    let simaAssessment =
      !lineItem.simaAssessment || lineItem.simaAssessment == "-999"
        ? 0
        : lineItem.simaAssessment;
    updatedTotalValue = updatedTotalValue + parseFloat(simaAssessment);
  });
  return parseFloat(updatedTotalValue).toFixed(2);
};

export const sumAllExciseTax = (lineItems) => {
  let updatedTotalValue = 0;
  lineItems.forEach((lineItem) => {
    let exciseTax =
      !lineItem.exciseTax || lineItem.exciseTax == "-999"
        ? 0
        : lineItem.exciseTax;
    updatedTotalValue = parseFloat(updatedTotalValue) + parseFloat(exciseTax);
  });
  return parseFloat(updatedTotalValue).toFixed(2);
};
// function getVfdDataValues(lineItemsData) {
//   let totalVfd = 0;
//   for (let i = 0; i < lineItemsData.length; i++) {
//     if (
//       lineItemsData[i].valueForDuty &&
//       parseFloat(lineItemsData[i].valueForDuty) > 0
//     ) {
//       totalVfd = totalVfd + parseFloat(lineItemsData[i].valueForDuty);
//     }
//   }
//   totalVfd = parseFloat(totalVfd);
//   return totalVfd;
// }
export const sumAllGst = (lineItems) => {
  let totalGST = 0;
  for (let i = 0; i < lineItems.length; i++) {
    let gst = parseFloat(lineItems[i].gst);
    totalGST += gst;
  }
  let FinalTotalGst = totalGST > 0 ? roundTo(totalGST, 2) : 0;

  return FinalTotalGst;
};

export const calculateTotals = (lineItems, actionPayload) => {
  let totalObj = {
    customsDuties: sumAllCustomDuties(lineItems),
    simaAssessment: sumAllSimaAssessment(lineItems),
    exciseTax: sumAllExciseTax(lineItems),
    gst: sumAllGst(lineItems),
  };
  let grandTotal = grandTotalValue(totalObj);
  totalObj.grandTotal = grandTotal.toFixed(2) || 0;
  return totalObj;
};
var finalAmount;
export const grandTotalValue = (totalField) => {
  let grandTotal = 0;
  grandTotal =
    parseFloat(totalField.customsDuties) +
    parseFloat(totalField.exciseTax) +
    parseFloat(totalField.simaAssessment) +
    totalField.gst;
  return parseFloat(Number(grandTotal).toFixed(2));
};

export const calculateCurrencyConversion = (qty, unitPrice) => {
  if (qty != "" && unitPrice != "") {
    return qty * unitPrice;
  } else {
    return "";
  }
};

export const calculateVFD = (currencyConversionVal, rateOfExchange) => {
  if (currencyConversionVal == "" || rateOfExchange == "") {
    return "";
  }
  return currencyConversionVal * rateOfExchange;
};

export const inCompletedPgaStatus = (merchandiseData) => {
  let inCompletedPga = [];
  for (let i = 0; i < merchandiseData.length; i++) {
    let pgaRullingApplicable = [];
    let pgaFlags = merchandiseData[i].pgaFlags;
    let htsDetail = merchandiseData[i].hsDataDtl;
    let PgaRullings = htsDetail.pgaRuling;
    if (PgaRullings && PgaRullings.length) {
      PgaRullings.forEach((element) => {
        pgaRullingApplicable.push(element.formType);
        if (element.formType == "TC" && pgaFlags["TCFlag"] == 2) {
          inCompletedPga.push({
            merchandiseId: merchandiseData[i]["merchandiseId"],
            fieldmessage: "#PGA : TC is not completed",
            fieldmessagetype: "FAIL",
          });
        }
      });
    }
  }
  return inCompletedPga;
};

export const validationForRequiredFields = (completeStore) => {
  let error = [];
  const merchandiseData =
    completeStore.DescriptionOfMerchandise.merchandiseLineItems;
  const entryType = completeStore.EntryTypeInfo;
  const transportation = completeStore.TransportationInfo;
  const declaration = completeStore.DeclarationSection;
  const incompletePga = inCompletedPgaStatus(merchandiseData);
  if (
    !transportation.USportOfUnladingCode ||
    (transportation.USportOfUnladingCode &&
      !transportation.USportOfUnladingCode.id)
  ) {
    error.push({
      fieldmessage: "Transportation: US Port of unlading is missing",
      fieldmessagetype: "FAIL",
    });
  }
  if (
    !transportation.foreignPortOfLadingCode ||
    (transportation.foreignPortOfLadingCode &&
      !transportation.foreignPortOfLadingCode.id)
  ) {
    error.push({
      fieldmessage: "Transportation: Foreign Port of unlading is missing",
      fieldmessagetype: "FAIL",
    });
  }
  if (!entryType.portCode || !entryType.portCode.id) {
    error.push({
      fieldmessage: "Entry type PortCode is missing",
      fieldmessagetype: "FAIL",
    });
  }
  if (
    !(
      (declaration.trueInvoiceFlag == 1 || declaration.bestInvoiceFlag == 1) &&
      (declaration.actualOwnerFlag == 1 || declaration.purchaserFlag == 1)
    )
  ) {
    error.push({
      fieldmessage: "Declaration Section is not completed",
      fieldmessagetype: "FAIL",
    });
  }
  if (incompletePga?.length) {
    error = error.concat(incompletePga);
  }
  return error;
};

export const currencyCodeMap = () => {
  return {
    Canadian_Dollar: "CAD",
    US_Dollar: "USD",
    Euro_Dollar: "EUR",
    Australian_Dollar: "AUD",
    Indian_Rupee: "INR",
    Chinese_Yuan_Renminbi: "CNY",
    Singapore_Dollar: "SGD",
    Netherlands_Antillean_Guilder: "ANG",
  };
};

export const usStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'DC',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const CAProvinces = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NT',
  'NS',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
];


export const canadaStates = [
  { id: 1, text: "Alberta", value: "AB" },
  { id: 2, text: "British Columbia", value: "BC" },
  { id: 3, text: "Manitoba", value: "MB" },
  { id: 4, text: "New Brunswick", value: "NB" },
  {
    id: 5,
    text: "New Foundland and Labrador",
    value: "NL",
  },
  { id: 6, text: "Nova Scotia", value: "NS" },
  { id: 7, text: "Northwest Territories", value: "NT" },
  { id: 8, text: "Nunavut", value: "NU" },
  { id: 9, text: "Ontario", value: "ON" },
  { id: 10, text: "Prince Edward Island", value: "PE" },
  { id: 11, text: "Quebec", value: "QC" },
  { id: 12, text: "Saskatchewan", value: "SK" },
  { id: 13, text: "Yukon Territory", value: "YT" },
];